// Dashboard App usage engagement page translations (pt-BR), loaded into dashboard.usage.engagement by ../pt-BR.usage.js
module.exports = {
  menu: "Engajamento",
  title: "Engajamento",
  description: "Quanto os utilizadores usam o aplicativo.",
  kpis: {
    eventViews: "Eventos visualizados",
    eventsCreated: "Eventos criados",
    eventShares: "Eventos partilhados",
    favorites: "Favoritos",
    messages: "Mensagens",
    checkIns: "Check-ins",
    mapClicks: "Cliques em mapas",
    searches: "Pesquisas realizadas",
    filterUses: "Uso de filtros",
  },
  info: {
    eventViews: "Visualizações únicas de eventos no período (cada utilizador conta uma vez por evento).\nFonte: Firebase (visualizações de eventos).",
    eventsCreated: "Eventos criados no período.\nFonte: Firebase (contadores de eventos).",
    eventShares: "Eventos partilhados no período.\nFonte: Firebase (contadores de eventos).",
    favorites: "Vezes que um utilizador marcou “Eu vou” num evento no período, enquanto a app não regista os favoritos com data.\nFonte: Firebase (contadores de eventos).",
    messages: "Mensagens de chat enviadas no período.\nFonte: Firebase (mensagens do chat).",
    checkIns: "Vezes que um utilizador marcou “Eu vou” num evento no período, enquanto a app não regista os check-ins com data.\nFonte: Firebase (contadores de eventos).",
    mapClicks: "Vezes que os ecrãs de mapa foram abertos na app Android no período.\nFonte: Google Analytics.",
    searches: "Pesquisas de eventos com texto feitas nas apps no período.\nFonte: Firebase (contadores de pesquisa).",
    filterUses: "Pesquisas de eventos com filtro feitas nas apps no período.\nFonte: Firebase (contadores de pesquisa).",
  },
  panels: {
    eventViews: "Eventos visualizados por {gran}",
    eventsCreated: "Eventos criados por {gran}",
    sections: "Uso por secção — % dos ativos",
    sectionsNote: "Utilizadores ativos com uma ação em cada secção: abrir um evento (Discover), divulgar ou dizer «Vou» (Timeline), seguir alguém (Perfil), enviar mensagens (Chat) e criar eventos na app (Creator).",
    screens: "Tempo médio em cada ecrã",
    screensNote: "Tempo médio por visita, só da app Android: a app iOS ainda não identifica os ecrãs no Firebase.",
  },
  hints: {
    noSource: "ainda não registado pela app",
  },
  sections: {
    discover: "Discover",
    timeline: "Timeline",
    profile: "Perfil",
    chat: "Chat",
    creator: "Creator",
  },
  screens: {
    home: "Início (Discover e Timeline)",
    map: "Mapa",
    event: "Evento",
    chat: "Chat",
    profile: "Perfil",
    creator: "Creator",
    search: "Pesquisa",
  },
  panelInfo: {
    eventViews: "Visualizações únicas de eventos em cada intervalo.\nFonte: Firebase (visualizações de eventos).",
    eventsCreated: "Eventos criados em cada intervalo.\nFonte: Firebase (contadores de eventos).",
    sections: "Parte dos utilizadores ativos com uma ação em cada secção da app.\nFonte: Firebase (as ações: visualizações, divulgações, “Eu vou”, seguidores, mensagens e eventos criados) e Google Analytics (sem ele, Firebase: registo de atividade enviado pelas apps) para os ativos.",
    screens: "Tempo médio por visita em cada ecrã da app Android.\nFonte: Google Analytics.",
  },
};
